/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Role_Owner_DInputs */

const en_mk_sec_pg_role_owner_d = /** @type {(inputs: Mk_Sec_Pg_Role_Owner_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manages the plan and billing, changes anybody’s role, and is the only one who can delete the workspace.`)
};

const id_mk_sec_pg_role_owner_d = /** @type {(inputs: Mk_Sec_Pg_Role_Owner_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengatur paket dan tagihan, mengubah peran siapa pun, dan satu-satunya yang bisa menghapus workspace.`)
};

/**
* | output |
* | --- |
* | "Manages the plan and billing, changes anybody’s role, and is the only one who can delete the workspace." |
*
* @param {Mk_Sec_Pg_Role_Owner_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_role_owner_d = /** @type {((inputs?: Mk_Sec_Pg_Role_Owner_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Role_Owner_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_role_owner_d(inputs)
	return en_mk_sec_pg_role_owner_d(inputs)
});